import { assign, sendParent } from '@monofront/xstate-v4';
import { SELECT_SHIPPING_METHOD_TRANSITIONS } from '../transitions';
import { SELECT_TIME_SLOTS_STATES } from './states';
import {
  ISelectDayEvent,
  ISelectHourEvent,
  ISelectTimeSlotsContext,
  ISelectTimeSlotsListResponseEvent,
} from './types';

export const sendSelectedTimeSlotToParent = sendParent<
  ISelectTimeSlotsContext,
  ISelectHourEvent
>((context) => ({
  type: SELECT_SHIPPING_METHOD_TRANSITIONS.SELECT_TIME_SLOT,
  timeSlotSelected: {
    deliveryDate: context.daySelected,
    timeSlot: context.hourSelected,
    timeSlotId: context.timeSlotId,
  },
}));

const sendSelectedTimeSlotFromDayChangedToParent = sendParent<
  ISelectTimeSlotsContext,
  ISelectDayEvent
>((context, event) => ({
  type: SELECT_SHIPPING_METHOD_TRANSITIONS.SELECT_TIME_SLOT,
  timeSlotSelected: {
    deliveryDate: event.daySelected,
    timeSlot: context.hourSelected,
    timeSlotId: context.timeSlotId,
  },
}));

export const assignSelectDay = assign<ISelectTimeSlotsContext, ISelectDayEvent>(
  {
    daySelected: (context, event) => event.daySelected ?? context.daySelected,
    hourSelected: (_, event) => event.hourSelected ?? null,
    timeSlotId: (_, event) => event.timeSlotId ?? null,
  },
);

export const assignSelectHour = assign<
  ISelectTimeSlotsContext,
  ISelectHourEvent
>({
  timeSlotId: (context, event) => event.timeSlotId ?? context.timeSlotId,
  hourSelected: (context, event) => event.hourSelected ?? context.hourSelected,
});

export const assignClearSelection = assign<ISelectTimeSlotsContext, any>({
  daySelected: () => null,
  hourSelected: () => null,
  timeSlotId: () => null,
});

export const assignSlotAvailabilitiesReceived = assign<
  ISelectTimeSlotsContext,
  ISelectTimeSlotsListResponseEvent
>({
  timeSlots: (_, event) => event.data.data.getSlotAvailabilitiesV2,
});

export const selectDayTransition = {
  target: SELECT_TIME_SLOTS_STATES.DAY_SELECTED,
  actions: [assignSelectDay, sendSelectedTimeSlotFromDayChangedToParent],
};

export const selectHourTransition = {
  target: SELECT_TIME_SLOTS_STATES.HOUR_SELECTED,
  actions: [assignSelectHour],
};

export const clearSelectionTransition = {
  target: SELECT_TIME_SLOTS_STATES.GET_SUCCESS,
  actions: [assignClearSelection],
};
